import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

interface DecodedToken {
  exp: number;
  [key: string]: any;
}

// Create an Axios instance

const apiJup = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_JUP_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': import.meta.env.VITE_FRONTEND_URL,
    'Origin': import.meta.env.VITE_FRONTEND_URL,
    'X-Origin': import.meta.env.VITE_CLIENT_DOMAIN,
    "ngrok-skip-browser-warning":true
  }
});

const api = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': import.meta.env.VITE_FRONTEND_URL,
    'Origin': import.meta.env.VITE_FRONTEND_URL,
    'X-Origin': import.meta.env.VITE_CLIENT_DOMAIN,
    "ngrok-skip-browser-warning":true
  }
});

// Add an interceptor to handle token refresh logic
api.interceptors.request.use(async (config) => {
  let token = localStorage.getItem('authToken');

  if (token) {
    try {
      const decoded: DecodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      // If the token will expire in less than 5 minutes, refresh it
      if (decoded.exp < currentTime + 5 * 60) {
        const response = await axios.post(`${import.meta.env.VITE_BACKEND_URL}/auth/refresh`, null, {
          headers: {
            Authorization: `Bearer ${token}`
          },
        });

        // Update the token in localStorage and Axios headers
        token = response.data.token;

        // Ensure token is not null before saving and updating
        if (token) {
          localStorage.setItem('authToken', token);
          config.headers['Authorization'] = `Bearer ${token}`;
        } else {
          throw new Error('Token refresh failed');
        }
      } else {
        // Attach the current token to the request headers
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error refreshing token:', error);
      // Clear the token if an error occurs and redirect to login
      localStorage.removeItem('authToken');
      window.location.href = '/auth';
    }
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

export {
  api,
  apiJup
};